import React from 'react';
import 'assets/scss/benefit-banner.scss';
import iconPig from 'assets/icons/static-content/icon_pig.svg';
import iconExecutive from 'assets/icons/static-content/icon_executive.svg';
import iconClock from 'assets/icons/static-content/icon_clock.svg';
import iconPadlock from 'assets/icons/static-content/icon_padlock.svg';

export const BenefitBanner = () => {
	return (
		<div className="benefit-container">
			<h2
				className="title-4 primary-color"
				style={{
					textAlign: 'center',
				}}
			>
				Ventajas de financiar con Crediautos
			</h2>
			<div className="benefit-container-items">
				<div className="benefit-box">
					<img src={iconPig} alt="" />
					<p className="body primary-color">Ahorra en tu cuota mensual </p>
					<div className="benefit-box-line" />
				</div>
				<div className="benefit-box">
					<img src={iconClock} alt="" />
					<p className="body primary-color">Pre aprobación en 60 Minutos</p>
					<div className="benefit-box-line" />
				</div>
				<div className="benefit-box">
					<img src={iconExecutive} alt="" />
					<p className="body primary-color">Servicio personalizado, crédito a tu medida</p>
					<div className="benefit-box-line" />
				</div>
				<div className="benefit-box">
					<img src={iconPadlock} alt="" />
					<p className="body primary-color">Tu deuda no se informa</p>
					<div className="benefit-box-line" />
				</div>
			</div>
		</div>
	);
};
